import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatSidenav } from '@angular/material';
import { Observable } from 'rxjs';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import { UserDocumentService } from 'src/app/services/user-document.service';
import { UtilityService } from 'src/app/services/utility.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AssetService } from '../../../services/asset.service';
import * as _ from 'lodash';
@Component({
  selector: 'app-medical-checklist',
  templateUrl: './medical-checklist.component.html',
  styleUrls: ['./medical-checklist.component.scss']
})
export class MedicalChecklistComponent implements OnInit {


  @Output() getFileDetails: EventEmitter<any> = new EventEmitter<any>();
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter();
  @Input('asset') assetData
  @Input('user') userData
  @Input('documentData') documentDetails
  @ViewChild('search', { static: false })
  @ViewChild('sidenav', { static: false }) public mydsidenav: MatSidenav;


  medicalChecklistForm: FormGroup
  isEdit: Boolean
  files: any = [];
  newFiles: any = [];
  public searchElementRef: ElementRef;
  userId: any;
  currentUser: any;
  medicalChecklistFormData = []
  selectedIndex
  previousIndex: any;
  bounds
  assetId
  loading
  selectedFormDetails
  _isControlDisable = false


  constructor(
    public dialog: MatDialog,
    public router: Router,
    public _utilityService: UtilityService,
    public _userDocumentService: UserDocumentService,
    public activatedRouter: ActivatedRoute,
    public _assetService: AssetService
  ) { }





  ngOnInit() {

    //route query params

    this.activatedRouter.params.subscribe(params => {
      this.assetId = params.id;
      console.log('check params data..', params, this.assetId)
    })

    this.currentUser = JSON.parse(localStorage.getItem('currentUser'))
    this.createForm()

  }





  ngOnChanges(changes: SimpleChanges): void {

    console.log("Inspection form changes", changes);
    if (changes.assetData && changes.assetData.currentValue) {
      this.assetData = changes.assetData.currentValue
      console.log("this.assetData", this.assetData);
    }

    if (changes.userData && changes.userData.currentValue) {
      this.userId = changes.userData.currentValue
      console.log("this.userData", this.userData);
    }

    if (changes.documentDetails && changes.documentDetails.currentValue) {

      let data = changes.documentDetails.currentValue
      console.log("data--->", data);

      let allFormList = data.filter((x) =>
        x.userDocumentId.documentMetaId.title === 'medicalChecklistForm'
      )
      console.log("same for data for multiple forms", allFormList);

      if (allFormList && allFormList.length) {
        this.medicalChecklistFormData = allFormList
        this.selectedIndex = this.medicalChecklistFormData[0]._id
        this.selectedFormDetails = this.medicalChecklistFormData[0].userDocumentId
        this._isControlDisable = true
        this.changeFormData()
        // this.createForm(this.medicalChecklistFormData[0].userDocumentId.details.medicalChecklistForm)
        this.files = this.selectedFormDetails.files && this.selectedFormDetails.files.length ? this.selectedFormDetails.files : []
        this.isEdit = true

      }


    }
  }



  // FORM GROUP

  createForm(data?) {
    console.log("here get data edit time ===>", data)
    this.medicalChecklistForm = new FormGroup({
      name: new FormControl((data && data.name) ? data.name : ''),
      serialNo: new FormControl((data && data.serialNo) ? data.serialNo : ''),
      calibrated: new FormControl((data && data.calibrated) ? data.calibrated : ''),
      callibrationDue: new FormControl((data && data.callibrationDue) ? data.callibrationDue : ''),
      workingOrder: new FormControl((data && data.workingOrder) ? data.workingOrder : '')
    })
    if (this._isControlDisable) {
      this.medicalChecklistForm.disable()
    }
  }







  // UTILITY

  changeFormDataMedical(event, id, index) {
    console.log("event", event);
    console.log("id", id);
    console.log("inspectionFormData", this.medicalChecklistFormData);
    console.log("index", index);
    this.selectedIndex = this.medicalChecklistFormData[index]._id
    this.selectedFormDetails = this.medicalChecklistFormData[index].userDocumentId
    this.files = this.selectedFormDetails.files && this.selectedFormDetails.files.length ? this.selectedFormDetails.files : []
    if (this.selectedIndex !== 'new') {
      this._isControlDisable = true
    } else {
      this._isControlDisable = false
    }
    this.createForm(this.selectedFormDetails.details.medicalChecklistForm)
    this.isEdit = true
  }


  changeFormData() {
    console.log("this.selectedFormDetails", this.selectedFormDetails);
    this.files = this.selectedFormDetails.files && this.selectedFormDetails.files.length ? this.selectedFormDetails.files : []
    this.isEdit = true
    this.createForm(this.selectedFormDetails.details.medicalChecklistForm)


  }

  onChangeEvent(value, formControl) {
    console.log("value of date", value);
    console.log('formControl', formControl);

    if (formControl == 'calibrated') {
      this.medicalChecklistForm.patchValue({ calibrated: value })
    }
    else if (formControl == 'callibrationDue') {
      this.medicalChecklistForm.patchValue({ callibrationDue: value })
    }


  }

  deleteFile(event, index) {
    console.log("event if file removed", event, this.isEdit);
    this.files.splice(index, 1)
    console.log("after file removd", this.files);

  }
  deleteNewFile(event, index) {
    this.newFiles.splice(index, 1)
  }


  addFileModal() {
    let obj = {
      isIncident: true
    }
    this._utilityService.commonDialogBoxOpen(NewFileModalComponent,
      obj, '', '100%', '100vw', '100vh').afterClosed().subscribe((fileQueue) => {
        console.log("The queue recieved is", fileQueue);
        if (fileQueue == undefined || fileQueue.length == 0) return;

        _.forEach(fileQueue, (file) => {
          if (this.isEdit) {
            this.newFiles.push(file)
          } else {
            this.files.push(file);
          }
        })
        this._utilityService.handleSnackBar({ msg: "File uploaded successfully!", button: "OK" })

      }, err => {
        this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
      });
  }




  addNewForm() {
    this._assetService.closeDisplayFile(true)
    let obj = {
      _id: 'new',
      submissionDate: new Date(),
      userDocumentId: {}
    }
    let details = {}
    details['medicalChecklistForm'] = {}
    obj.userDocumentId['details'] = details
    this.medicalChecklistFormData.push(obj)
    this.selectedIndex = this.medicalChecklistFormData[this.medicalChecklistFormData.length - 1]._id
    this.selectedFormDetails = this.medicalChecklistFormData[this.medicalChecklistFormData.length - 1].userDocumentId
    this._isControlDisable = false
    // this.medicalChecklistFormData = []
    this.createForm({})
    this.isEdit = false
    this.files = []
  }



  fileDetails(event) {
    console.log("event ====", event);
    this.previousIndex = event.index
    this.openFilesSideNav.emit({ event })
  }





  // API CALL

  onSubmit() {
    this.loading = true
    if (this.medicalChecklistForm.valid) {
      console.log('formgroup value', this.medicalChecklistForm.value);
      console.log('file value', this.files);

      if (this.isEdit) {
        let obj = {
          metaObj: {
            title: 'medicalChecklistForm',
          },
          documentId: this.selectedFormDetails.documentId,
          userId: this.userId,
          onModel: 'asset',
          documentMetaId: this.selectedFormDetails.documentMetaId,
          userDocumentId: this.selectedFormDetails._id,
          files: this.files,
          newFiles: this.newFiles,
          details: {}
        }

        let details = {
          medicalChecklistForm: this.medicalChecklistForm.value
        }

        obj['details'] = details
        this._userDocumentService.updateUserDocument(obj).subscribe((response) => {
          console.log("response of new user document", response);
          this._utilityService.handleSnackBar({ msg: "Data updated successfully!", button: "OK" })
          this.loading = false
          this.redirect();
        }, error => {
          console.log("error while submit form", error);
          this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
          this.loading = false
        })


      } else {

        let obj = {
          metaObj: {
            title: 'medicalChecklistForm',
          },
          documentId: this.assetId,
          userId: this.userId,
          onModel: 'asset',
          files: this.files,
          details: {}
        }


        let details = {
          medicalChecklistForm: this.medicalChecklistForm.value
        }
        obj['details'] = details

        this._assetService.submitAssetForm(obj).subscribe((response) => {
          console.log("response of new user document", response);
          this._utilityService.handleSnackBar({ msg: "Data added successfully!", button: "OK" })
          this.loading = false
          this.redirect();
        }, error => {
          console.log("error while submit form", error);
          this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
          this.loading = false
        })
      }
    }

    else {
      this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
      this.loading = false
    }
  }




  redirect() {
    this._assetService.closeDisplayFile(true)
    if (this.currentUser && (this.currentUser.userRole.includes('admin') || this.currentUser.userRole.includes('assetManager'))) {
      console.log("user is admin");
      this.router.navigate(['/asset/single-asset/' + this.assetData])
    }
    else {
      this.router.navigate(['/asset/asset-list/'])
    }
  }

}
